<template>
  <v-card tile flat>
    <v-toolbar v-if="title" dense flat class="one-row">
      <v-icon v-if="showClose" class="close" @click="closeModal">$sl-close</v-icon>
      <h2>
        {{ title }}
      </h2>
    </v-toolbar>
    <v-card-text class="pl-0 pr-0 py-0 mt-0"
      ><b>{{ subtitle }}</b></v-card-text
    >

    <v-card-text class="body-1" v-html="text" />

    <v-card-actions v-if="actions && Object.keys(actions).length" class="d-flex justify-end mt-2 flex-column">
      <template v-for="action in actions">
        <ActionButton
          :disabled="action.disabled"
          @click="handleClick(action)"
          :key="action.text"
          :actionIcon="action.icon"
          class="ml-0 mt-6"
          :outlined="action.outlined"
        >
          {{ action.text }}
        </ActionButton>
      </template>
    </v-card-actions>
    <v-card-text class="">
      <v-checkbox v-model="selected" :false-value="false" :true-value="true" :label="label"></v-checkbox>
    </v-card-text>
  </v-card>
</template>

<script>
import Confirmable from 'vuedl/src/mixins/confirmable'
import ActionButton from '@/components/Common/ActionButton'

export default {
  name: 'DialogWithCheckbox',
  components: {
    ActionButton
  },
  layout: ['default', {width: 450}],
  mixins: [Confirmable],
  props: {
    actionOptions: Object,
    title: String,
    subtitle: String,
    text: {
      type: String,
      required: true,
      default: ''
    },
    label: String,
    showClose: Boolean
  },
  data: () => ({
    selected: false
  }),
  methods: {
    handleClick(data) {
      this.$emit('submit', {data: data.key, checkbox: this.selected})
    }
  }
}
</script>